import { createClient } from '@supabase/supabase-js'
import { config, configurationError } from '../config.js'

let client = null

export function getSupabase() {
  if (config.e2e) return null
  if (configurationError()) return null
  if (!client) {
    client = createClient(config.supabaseUrl, config.supabaseAnonKey, {
      auth: { flowType: 'pkce', persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
  }
  return client
}

export async function accessToken() {
  const sb = getSupabase()
  if (!sb) return null
  const { data } = await sb.auth.getSession()
  return data.session?.access_token || null
}
